module.exports = __webpack_public_path__ + "Flag-795.05a83359956ee7f5f5036639613b283a.svg";